import React from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
// import fileDownload from 'js-file-download';
import Summary from './Summary';
import Table from './Table';

class Results extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      alertVisible: true,
    };
    this.onDismiss = this.onDismiss.bind(this);
  }

  /* unused
  downloadFile = () => {
    const { leadsFile, leadsData } = this.props;
    fileDownload(leadsData, leadsFile);
  };
  */

  onDismiss = () => {
    this.setState({ alertVisible: false });
  };

  render() {
    const { hasResults, tab, leadsFile } = this.props;
    const { alertVisible } = this.state;

    const leadsFileError = leadsFile.includes('lead_upload_errors');

    const errMsg = `Leads were successfully loaded with some errors.
    Please download the results for details.`;

    const successMsg = `Success! Leads file was successfully uploaded.
    Please check the uploads history to download the results. Keep in mind
    it may take a few minutes for a larger file to be processed.`;

    return (
      <div className="w-100">
        {
          (tab === 'leads' || tab === 'leads_reassignment')
            ? (
              <div className="text-center">
                <Alert color={leadsFileError ? 'warning' : 'success'} isOpen={alertVisible} toggle={this.onDismiss}>
                  {
                    leadsFileError
                      ? errMsg
                      : successMsg
                  }
                </Alert>
              </div>
            ) : <Summary />
        }

        {hasResults && (
          <Table />
        )}
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  hasResults: store.batch.results.length > 0,
  tab: store.batch.tab,
  token: store.auth.token,
  site: store.theme.site,
  previewing: store.batch.previewing,
  leadsFile: store.batch.leadsFile,
  leadsData: store.batch.leadsData,
});

export default connect(mapStateToProps)(Results);
